// src/services/api/folder.js
import apiClient from './config';
import { queryCache } from "../../lib/queryCache";

export const getFolders = async () => {
  console.log('[API] getFolders called');
  try {
    const response = await apiClient.get('/folders');
    const folders = response.data?.folders ?? response.data;
    console.log('[API] getFolders success:', folders?.length || 0, 'folders');
    return folders;
  } catch (error) {
    console.error('[API] getFolders ERROR:', error.message);
    throw error;
  }
};

export const getArchivedFolders = async () => {
  console.log('[API] getArchivedFolders called');
  try {
    const response = await apiClient.get('/folders/archived');
    const folders = response.data?.folders ?? response.data;
    console.log('[API] getArchivedFolders success:', folders?.length || 0, 'archived folders');
    return folders;
  } catch (error) {
    console.error('[API] getArchivedFolders ERROR:', error.message);
    throw error;
  }
};

export const createFolder = async (folderData) => {
  console.log('[API] createFolder called with:', folderData);
  try {
    const response = await apiClient.post('/folders', folderData);
    console.log('[API] createFolder success');
    queryCache.invalidate("library_folders");
    return response.data?.folder ?? response.data;
  } catch (error) {
    console.error('[API] createFolder ERROR:', error.message);
    throw error;
  }
};

export const updateFolder = async (folderId, updates) => {
  console.log(`[API] updateFolder called for ID: ${folderId} with:`, updates);
  try {
    const response = await apiClient.patch(`/folders/${folderId}`, updates);
    console.log('[API] updateFolder success');
    queryCache.invalidate("library_folders");
    queryCache.invalidate(`folder_files_${folderId}`);
    if (updates.archived !== undefined) {
      queryCache.invalidate("library_recent_notes");
    }
    return response.data?.folder ?? response.data;
  } catch (error) {
    console.error('[API] updateFolder ERROR:', error.message);
    throw error;
  }
};

export const getFolderFiles = async (folderId, force = false) => {
  if (!folderId) throw new Error('folderId is required');
  const cacheKey = `folder_files_${folderId}`;

  if (!force) {
    const cached = queryCache.get(cacheKey);
    if (cached) {
      return cached;
    }
  }

  try {
    const response = await apiClient.get(`/folders/${folderId}/files`);
    const files = response.data?.files ?? response.data;
    console.log(`[API] getFolderFiles success. Found ${files?.length || 0} files.`);
    if (files) {
      queryCache.set(cacheKey, files, 5 * 60 * 1000); // 5 mins TTL
    }
    return files;
  } catch (error) {
    console.error('[API] getFolderFiles ERROR:', error.message);
    throw error;
  }
};

// ✅ Delete Folder Function
export const deleteFolder = async (folderId) => {
  console.log(`[API] deleteFolder called for ID: ${folderId}`);
  try {
    const response = await apiClient.delete(`/folders/${folderId}`);
    console.log('[API] deleteFolder success');
    queryCache.invalidate("library_folders");
    queryCache.invalidate(`folder_files_${folderId}`);
    return response.data;
  } catch (error) {
    console.error('[API] deleteFolder ERROR:', error.message);
    throw error;
  }
};